import React from "react";
import { formatItalianNumber } from "../utils/formatItalianNumber";

const euro = (value) => `${formatItalianNumber(value, {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})}\u00a0€`;

const LABELS = { Z: "Zucchetti", B: "Bpoint", I: "iiPay" };

export const TotalSectionCard = ({ total, totalsByType = {}, onClick, className = "" }) => (
  <div
    role={onClick ? "button" : undefined}
    tabIndex={onClick ? 0 : undefined}
    onClick={onClick}
    onKeyDown={(event) => {
      if (onClick && (event.key === "Enter" || event.key === " ")) onClick();
    }}
    className={`rounded-xl border border-blue-200 bg-blue-50 p-4 text-blue-800 shadow-sm ${onClick ? "cursor-pointer transition hover:shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500" : ""} ${className}`}
  >
    <div className="text-xs font-semibold uppercase tracking-wide opacity-70">Totale sezione</div>
    <div className="mt-1 text-2xl font-bold">{euro(total)}</div>
    <div className="mt-2 flex flex-wrap gap-x-4 gap-y-1 border-t border-blue-800/40 pt-2 text-xs font-semibold opacity-80">
      {Object.entries(totalsByType).map(([tipo, value]) => (
        <span key={tipo}>{LABELS[tipo] || tipo}: {euro(value)}</span>
      ))}
    </div>
  </div>
);
